import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { InsidecharterViewComponent } from './insidecharter-view.component';

const routes: Routes = [
  {
    path: '',
    component: InsidecharterViewComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class InsidecharterViewRoutingModule {}